import { useEffect, useRef } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { getPrinterConfig, isPrinterConfigured, printTicket } from "@/lib/escpos";

const SEEN = "menuone_printed_orders";
const seen = () => { try { return new Set(JSON.parse(sessionStorage.getItem(SEEN)) || []); } catch { return new Set(); } };
const markSeen = (s) => sessionStorage.setItem(SEEN, JSON.stringify([...s].slice(-300)));

// Stampa automatica degli ordini clienti (QR) appena arrivano, su qualsiasi pagina della dashboard
export function useAutoPrint(enabled, restaurantName) {
  const first = useRef(true);
  useEffect(() => {
    if (!enabled) return;
    const tick = async () => {
      const cfg = getPrinterConfig();
      if (!isPrinterConfigured() || cfg?.autoCustomer === false) return;
      try {
        const { data } = await api.get("/orders");
        const s = seen();
        if (first.current) { data.forEach((o) => s.add(o.id)); markSeen(s); first.current = false; return; }
        for (const o of data.filter((x) => !s.has(x.id) && x.source !== "staff")) {
          s.add(o.id); markSeen(s);
          try { await printTicket(o, restaurantName); } catch (e) { toast.error(`Stampa ordine #${o.order_no} non riuscita: ${e.message}`); }
        }
      } catch { /* offline: riprova al prossimo giro */ }
    };
    tick();
    const id = setInterval(tick, 15000);
    return () => clearInterval(id);
  }, [enabled, restaurantName]);
}
